import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { ButtonType } from '../advanced/buttons/types/ButtonEnums.ts';

export interface IButtonTypeSelectInputProps {
  name: string;
  defaultValue?: ButtonType;
  placeholder?: string;
}

export function ButtonTypeSelectInput(props: IButtonTypeSelectInputProps) {
  const { name, defaultValue, placeholder } = props;
  return (
    <SelectInput
      name={name}
      defaultValue={defaultValue}
      placeholder={placeholder}
      options={[
        {
          label: 'Primario',
          value: ButtonType.Primary,
        },
        {
          label: 'Secondario',
          value: ButtonType.Default,
        },
        {
          label: 'Come Link',
          value: ButtonType.Link,
        },
      ]}
    />
  );
}
